<template>
  <div class="overview-page">
    <h1 class="page-title">AI工具管理</h1>
    <v-container>
      <!-- 篩選條 -->
      <v-card class="filter-card">
        <v-row class="filter-row" align="center" justify="center" dense>
          <v-col cols="12" sm="6" md="4">
            <div class="answer-input">
              <!-- 名稱輸入框 -->
              <input type="text" id="name-input" v-model="filters.name" placeholder="請輸入名稱"
                class="answer-input-field" />
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <div class="answer-input">
              <!-- 是否開源下拉選單 -->
              <select id="is-open-source" v-model="filters.is_open_source" class="answer-input-field">
                <option disabled value="">請選擇是否開源</option>
                <option value="開源">開源</option>
                <option value="閉源">閉源</option>
                <option value="未知">未知</option>
              </select>
            </div>
          </v-col>

          <!-- 工具大分類 -->
          <v-col cols="12" sm="6" md="4">
            <div class="answer-input">

              <select id="main-category" v-model="filters.main_category" class="answer-input-field">
                <option disabled value="">請選擇工具大分類</option>
                <option v-for="category in categories" :key="category" :value="category">
                  {{ category }}
                </option>
              </select>
            </div>
          </v-col>
          <!-- 語系 -->
          <!-- <v-col cols="12" sm="6" md="3">
            <div class="answer-input">
              <v-select v-model="filters.language" :items="['英文', '繁體中文', '其他']" label="請選擇語系" multiple outlined
                dense></v-select>
            </div>
          </v-col> -->

          <v-col cols="12" sm="6" md="4">
            <VueDatePicker v-model="filters.creationDateRange" range locale="Zh" :format="formatRange"
              placeholder="最新版本日期範圍" type="date" :enable-time="false" :show-action-buttons="false" :week-start="0"
              class="custom-datepicker" teleport="body"
              @update:modelValue="(value) => handleDateRangeChange('creationDateRange', value)" />

          </v-col>
          <!-- 狀態 -->
          <v-col cols="12" sm="6" md="4">
            <div class="answer-input">

              <select id="status" v-model="filters.status" class="answer-input-field">
                <option disabled value="">請選擇狀態</option>
                <option value="待審核">待審核</option>
                <option value="已審核">已審核</option>
              </select>
            </div>
          </v-col>

          <!-- 上架 -->
          <v-col cols="12" sm="6" md="4">
            <div class="answer-input">

              <select id="is-published" v-model="filters.is_published" class="answer-input-field">
                <option disabled value="">請選擇是否上架</option>
                <option value="是">是</option>
                <option value="否">否</option>
              </select>
            </div>
          </v-col>

          <!-- <v-col cols="12" sm="6" md="3">
            <VueDatePicker v-model="filters.modificationDateRange" range locale="Zh" :format="formatRange"
              placeholder="上架日期範圍" type="date" :enable-time="false" :show-action-buttons="false" :week-start="0"
              class="custom-field" teleport="body"
              @update:modelValue="(value) => handleDateRangeChange('modificationDateRange', value)" />
          </v-col> -->

        </v-row>

        <!-- 查詢與清除按鈕 -->
        <v-row class="filter-actions" align="center" justify="end">
          <!-- <v-btn outlined color="primary" @click="applyFilters">查詢</v-btn> -->
          <v-btn outlined color="secondary" @click="clearFilters" class="ml-2">清除</v-btn>
        </v-row>
      </v-card>

      <!-- 資料表 -->
      <v-card class="table-card">
        <!-- 新增工具按鍵 -->
        <div class="table-header-row">
          <v-row align="center" justify="space-between" class="header-options">
            <!-- 每頁顯示筆數選擇器 -->
            <v-col cols="auto">
              <v-row align="center" class="dropdown-wrapper">
                <span class="dropdown-label">每頁顯示:</span>
                <div class="dropdown-container" ref="dropdownRef">
                  <div class="dropdown-selected" @click="toggleDropdown">
                    {{ itemsPerPage }}
                    <span class="dropdown-icon">▼</span>
                  </div>
                  <ul v-if="dropdownOpen" class="dropdown-menu">
                    <li v-for="item in [5, 10, 20, 50]" :key="item" @click="selectItemsPerPage(item)"
                      class="dropdown-item" :class="{ active: item === itemsPerPage }">
                      {{ item }}
                    </li>
                  </ul>
                </div>

              </v-row>
            </v-col>


            <!-- 新增工具按鍵 -->
            <v-col cols="auto">
              <v-btn outlined color="primary" @click="openSortDialog" class="mr-2">編輯首頁工具順序</v-btn>
              <v-btn class="add-tool-btn" color="primary" outlined @click="addTool">
                新增工具
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- 表格內容 -->
        <table class="custom-table">
          <thead>
            <tr>
              <!-- 逐一指定表頭名稱 -->
              <th class="table-header" @click="sortTable('id')">
                <div class="header-container">
                  <span>ID</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('id') }}</v-icon>
                </div>
              </th>
              <th class="table-header" @click="sortTable('name')">
                <div class="header-container">
                  <span>名稱</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('name') }}</v-icon>
                </div>
              </th>
              <th class="table-header" @click="sortTable('is_open_source')">
                <div class="header-container">
                  <span>是否開源</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('is_open_source') }}</v-icon>
                </div>
              </th>
              <th class="table-header" @click="sortTable('main_category')">
                <div class="header-container">
                  <span>工具大分類</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('main_category') }}</v-icon>
                </div>
              </th>
              <th class="table-header" @click="sortTable('latest_version_date')">
                <div class="header-container">
                  <span>最新版本日期</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('latest_version_date') }}</v-icon>
                </div>
              </th>
              <th class="table-header" @click="sortTable('status')">
                <div class="header-container">
                  <span>狀態</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('status') }}</v-icon>
                </div>
              </th>
              <th class="table-header" @click="sortTable('is_published')">
                <div class="header-container">
                  <span>上架</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('is_published') }}</v-icon>
                </div>
              </th>
              <th class="table-header actions-column">
                <div class="header-container">
                  <span>操作</span>
                </div>
              </th>
              <th class="table-header" @click="sortTable('recommend')">
                <div class="header-container">
                  <span>推薦</span>
                  <v-icon small class="sort-icon">{{ getSortIcon('recommend') }}</v-icon>
                </div>
              </th>
            </tr>
          </thead>


          <tbody>
            <tr v-for="item in paginatedItems" :key="item.id">
              <td class="table-cell">{{ item.id }}</td>
              <td class="table-cell">{{ item.name }}</td>
              <td class="table-cell">{{ item.is_open_source }}</td>
              <td class="table-cell">{{ item.main_category }}</td>
              <!-- <td class="table-cell">{{ formatLanguage(item.language) }}</td> -->
              <td class="table-cell">{{ formatDate(item.latest_version_date) }}</td>
              <td class="table-cell">{{ item.status }}</td>
              <td class="table-cell">{{ item.is_published }}</td>
              <!-- <td class="table-cell">{{ formatDate(item.release_date) }}</td> -->
              <td class="table-cell actions-cell">
                <v-icon small class="action-icon"
                  @click="$router.push({ name: 'ViewTool', params: { codeno: item.id } })">
                  mdi-eye
                </v-icon>
                <v-icon small class="action-icon"
                  @click="$router.push({ name: 'EditTool', params: { codeno: item.id } })">
                  mdi-pencil
                </v-icon>
                <v-btn small outlined @click="openDialog('audit', item)"
                  :disabled="!(item.status === '待審核' || item.status === '不通過')"
                  :class="{ 'btn-disabled': !(item.status === '待審核' || item.status === '不通過') }" class="action-btn">
                  審核
                </v-btn>
                <v-btn v-if="item.is_published === '否'" small outlined color="green"
                  @click="openDialog('publish', item)" :disabled="item.status !== '已審核'"
                  :class="{ 'btn-disabled': item.status !== '已審核' }" class="action-btn">
                  上架
                </v-btn>
                <v-btn v-else small outlined color="red" @click="item.status === '已審核' && openDialog('disable', item)"
                  :disabled="item.status !== '已審核'" :class="{ 'btn-disabled': item.status !== '已審核' }"
                  class="action-btn">
                  下架
                </v-btn>
              </td>
              <td class="table-cell">
                <v-icon :color="item.recommend ? 'primary' : 'grey lighten-3'" :class="{ 'clickable-icon': true }"
                  @click="toggleRecommend(item)">
                  {{ item.recommend ? 'mdi-thumb-up' : 'mdi-thumb-up-outline' }}
                </v-icon>
              </td>

            </tr>
          </tbody>
        </table>
      </v-card>
      <v-row justify="center" class="pagination-container">
        <!-- 上一頁按鈕 -->
        <button v-if="currentPage > 1" class="arrow-btn" @click="goToPreviousPage">
          <v-icon>mdi-chevron-left</v-icon>
        </button>

        <!-- 動態生成頁碼 -->
        <button v-for="page in visiblePages" :key="page" class="page-btn"
          :class="{ 'btn-active': page === currentPage }" @click="page !== '...' && goToPage(page)"
          :disabled="page === '...' || page === currentPage">
          {{ page }}
        </button>

        <!-- 下一頁按鈕 -->
        <button v-if="currentPage < totalPages" class="arrow-btn" @click="goToNextPage">
          <v-icon>mdi-chevron-right</v-icon>
        </button>
      </v-row>



    </v-container>


    <!-- 編輯順序的對話框 -->
    <v-dialog v-model="sortDialogVisible" :key="sortDialogKey" max-width="600px">
      <v-card>
        <v-card-title class="text-h6">編輯首頁工具順序</v-card-title>
        <v-card-text>
          <table class="custom-table">
            <thead>
              <tr>
                <th>順序</th>
                <th>名稱</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tool, index) in sortedTools" :key="tool.Codeno">
                <td>{{ tool.SortBy }}</td>
                <td>{{ tool.Name }}</td>
                <td>
                  <v-btn small icon @click="moveUp(index)" :disabled="index === 0">
                    <v-icon>mdi-chevron-up</v-icon>
                  </v-btn>
                  <v-btn small icon @click="moveDown(index)" :disabled="index === sortedTools.length - 1">
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </td>


              </tr>
            </tbody>
          </table>
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogVisible" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">
          {{ dialogType === 'audit' ? '審核工具' : dialogType === 'publish' ? '上架工具' : '下架工具' }}
        </v-card-title>
        <v-card-text>
          <p>工具名稱：{{ selectedTool.name }}</p>

          <!-- 審核邏輯 -->
          <v-radio-group v-if="dialogType === 'audit'" v-model="auditStatus" row>
            <v-radio label="通過" value="passed"></v-radio>
            <v-radio label="不通過" value="failed"></v-radio>
          </v-radio-group>

          <v-textarea v-if="dialogType === 'audit' && auditStatus === 'failed'" v-model="reason" label="未通過理由" outlined
            dense></v-textarea>

          <!-- 上架邏輯 -->
          <p v-if="dialogType === 'publish'">請確認是否上架此工具。</p>

          <!-- 下架邏輯 -->
          <v-textarea v-if="dialogType === 'disable'" v-model="reason" label="下架理由" outlined dense></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="confirmAction">確認</v-btn>
          <v-btn color="secondary" text @click="closeDialog">取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>


<script>
import axios from "axios";

export default {
  created() {
    this.fetchRecommendedTools().then(() => {
      this.fetchTools();
    });
  }
  ,
  mounted() {
    this.dropdownRef = this.$refs.dropdownRef;
    document.addEventListener("click", this.handleGlobalClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleGlobalClick);
  },

  name: "DashboardOverview",
  data() {
    return {
      categories: ["應用工具", "開發工具", "語言模型"],
      statuses: ["上架", "下架", "維護中"],
      filters: {
        name: "",
        is_open_source: "",
        main_category: "",
        language: [], // 確保是空數組
        status: "",
        is_published: "",
        creationDateRange: [], // 初始化為空數組
        modificationDateRange: [], // 初始化為空數組

      },
      headers: [
        { text: "ID", value: "id" },
        { text: "名稱", value: "name" },
        { text: "是否開源", value: "is_open_source" },
        { text: "工具大分類", value: "main_category" },
        // { text: "語系", value: "language" },
        { text: "最新版本日期", value: "latest_version_date" },
        { text: "狀態", value: "status" },
        { text: "上架", value: "is_published" },
        { text: "推薦", value: "recommend" }, // 🔥 新增推薦欄位
        // { text: "上架日期", value: "release_date" },
      ],
      items: [
      ],
      sortKey: "latest_version_date",
      sortOrder: "desc", // 'asc' or 'desc'
      dialogVisible: false,  // 對話框是否顯示
      dialogType: "",        // 對話框類型 ('audit' 或 'publish')
      selectedTool: {},      // 被選中的工具
      auditStatus: "",       // 審核狀態
      reason: "",            // 未通過理由或其他輸入
      addDialogVisible: false, // 控制新增工具對話框的顯示
      newToolData: {},
      dropdownOpen: false, // 控制選單開啟或關閉
      dropdownRef: null,
      itemsPerPage: 10, // 預設每頁顯示 10 筆
      currentPage: 1, // 當前頁數
      recommendedTools: [], // 🔥 存放推薦工具的 codeno
      sortDialogVisible: false, // 控制編輯順序對話框顯示
      sortedTools: [], // 用於排序的工具數據
    };
  },

  computed: {

    filteredItems() {
      return this.items.filter((item) => {
        // 名稱篩選
        const matchesName =
          !this.filters.name || item.name.toLowerCase().includes(this.filters.name.toLowerCase());

        // 是否開源篩選
        const matchesOpenSource =
          !this.filters.is_open_source || item.is_open_source === this.filters.is_open_source;

        // 工具大分類篩選
        const matchesMainCategory =
          !this.filters.main_category || item.main_category === this.filters.main_category;

        const matchesLanguage = (() => {
          // 確保篩選條件是有效的陣列
          if (!Array.isArray(this.filters.language)) return false;

          // 如果篩選條件為空，直接通過
          if (this.filters.language.length === 0) return true;

          // 確保 item.spoken_language 是有效陣列
          if (!Array.isArray(item.spoken_language)) return false;

          // 檢查是否有任何語言符合條件
          return this.filters.language.some((lang) => item.spoken_language.includes(lang));
        })();




        // 狀態篩選
        const matchesStatus =
          !this.filters.status || item.status === this.filters.status;

        // 是否上架篩選
        const matchesIsPublished =
          !this.filters.is_published || item.is_published === this.filters.is_published;

        // 最新版本日期範圍篩選
        const creationDateRange = this.filters.creationDateRange.map((date) =>
          this.formatToDateOnly(date)
        );
        const matchesLatestVersionDateRange =
          !creationDateRange.length ||
          (item.latest_version_date &&
            this.formatToDateOnly(item.latest_version_date) >= creationDateRange[0] &&
            this.formatToDateOnly(item.latest_version_date) <= creationDateRange[1]);

        // 上架日期範圍篩選
        const modificationDateRange = this.filters.modificationDateRange.map((date) =>
          this.formatToDateOnly(date)
        );
        const matchesReleaseDateRange =
          !modificationDateRange.length ||
          (item.release_date &&
            this.formatToDateOnly(item.release_date) >= modificationDateRange[0] &&
            this.formatToDateOnly(item.release_date) <= modificationDateRange[1]);

        // 返回匹配的項目
        return (
          matchesName &&
          matchesOpenSource &&
          matchesMainCategory &&
          matchesLanguage &&
          matchesStatus &&
          matchesIsPublished &&
          matchesLatestVersionDateRange &&
          matchesReleaseDateRange
        );
      });
    },
    visiblePages() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      const pages = [];

      if (totalPages <= 5) {
        // 如果總頁數小於等於 5，直接顯示所有頁碼
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // 顯示前 3 頁
        if (currentPage <= 3) {
          for (let i = 1; i <= 3; i++) {
            pages.push(i);
          }
          if (totalPages > 5) pages.push("...");
          pages.push(totalPages);
        }
        // 顯示中間頁碼
        else if (currentPage > 3 && currentPage < totalPages - 2) {
          pages.push(1);
          pages.push("...");
          pages.push(currentPage - 1, currentPage, currentPage + 1);
          pages.push("...");
          pages.push(totalPages);
        }
        // 顯示後 3 頁
        else {
          pages.push(1);
          if (totalPages > 5) pages.push("...");
          for (let i = totalPages - 2; i <= totalPages; i++) {
            pages.push(i);
          }
        }
      }

      return pages;
    },
    totalPages() {
      return Math.ceil(this.filteredItems.length / this.itemsPerPage); // 動態計算總頁數
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.currentPage * this.itemsPerPage;
      return this.filteredItems.slice(start, end);
    },

  },


  methods: {
    async openSortDialog() {
      console.log("開啟編輯順序對話框");
      this.sortDialogVisible = true;

      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const response = await axios.get(`${baseUrl}/searchRecommend`);

        if (response.data.rtnCode === "0000") {
          this.sortedTools = response.data.data.sort((a, b) => a.SortBy - b.SortBy);
          console.log("排序工具數據：", this.sortedTools);

          // **重新排序工具清單**
          await this.fetchTools(); // 確保 `fetchTools()` 根據 `sortedTools` 重新排序
        } else {
          console.error("排序工具數據獲取失敗：", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("API 請求錯誤：", error);
      }
    }

    ,

    async moveUp(index) {
      if (index === 0) return; // 已經是第一個，不用處理

      const tool = this.sortedTools[index];

      try {
        const baseUrl = process.env.VUE_APP_BASE_URL || `${process.env.VUE_APP_SERVICE_URL}/api/v1`;
        await axios.post(`${baseUrl}/ToolsRecommendUpd/${tool.Codeno}`, { sortBy: -1 });

        // 重新取得最新排序的工具列表
        await this.openSortDialog();
      } catch (error) {
        console.error("移動上失敗:", error);
        alert("移動失敗，請稍後再試。");
      }
    }
    ,

    async moveDown(index) {
      if (index === this.sortedTools.length - 1) return; // 已經是最後一個，不用處理

      const tool = this.sortedTools[index];

      try {
        const baseUrl = process.env.VUE_APP_BASE_URL || `${process.env.VUE_APP_SERVICE_URL}/api/v1`;
        await axios.post(`${baseUrl}/ToolsRecommendUpd/${tool.Codeno}`, { sortBy: 1 });

        // 重新取得最新排序的工具列表
        await this.openSortDialog();
      } catch (error) {
        console.error("移動下失敗:", error);
        alert("移動失敗，請稍後再試。");
      }
    }
    ,
    async saveSortOrder() {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;

        const payload = this.sortedTools.map((tool) => ({
          Codeno: tool.Codeno,
          SortBy: tool.SortBy,
        }));

        const response = await axios.post(`${baseUrl}/saveRecommendSort`, { data: payload });

        if (response.data.rtnCode === "0000") {
          alert("排序保存成功！");
          this.sortDialogVisible = false;
          this.fetchTools(); // 刷新工具列表
        } else {
          console.error("保存排序失敗:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("保存排序請求失敗:", error);
      }
    },

    // 關閉對話框
    closeSortDialog() {
      this.sortDialogVisible = false;
    },

    async toggleRecommend(item) {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;

        const apiEndpoint = item.recommend
          ? `${baseUrl}/ToolsRecommendNot/${item.id}`
          : `${baseUrl}/ToolsRecommend/${item.id}`;

        const response = await axios.post(apiEndpoint);

        if (response.data.rtnCode === "0000") {
          item.recommend = !item.recommend; // 成功後切換推薦狀態
        } else {
          console.error("API 錯誤:", response.data.rtnMsg);
          alert(`操作失敗: ${response.data.rtnMsg}`);
        }
      } catch (error) {
        console.error("API 請求失敗:", error);
        alert("操作失敗，請稍後再試。");
      }
    },
    async fetchRecommendedTools() {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;
        const response = await axios.get(`${baseUrl}/searchRecommend`);

        if (response.data.rtnCode === "0000") {
          this.recommendedTools = response.data.data.map(tool => tool.Codeno);
        } else {
          console.error("推薦工具 API 錯誤:", response.data.rtnMsg);
        }
      } catch (error) {
        console.error("獲取推薦工具失敗:", error);
      }
    },
    applySort() {
      if (!this.sortKey) return; // 如果沒有排序字段，直接返回
      this.items.sort((a, b) => {
        const valueA = a[this.sortKey];
        const valueB = b[this.sortKey];

        if (this.sortOrder === "asc") {
          return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
        } else {
          return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
        }
      });
    },
    saveSortState() {
      localStorage.setItem("sortKey", this.sortKey); // 保存排序字段
      localStorage.setItem("sortOrder", this.sortOrder); // 保存排序順序
    },
    loadSortState() {
      this.sortKey = localStorage.getItem("sortKey") || ""; // 如果無值，預設為空
      this.sortOrder = localStorage.getItem("sortOrder") || "asc"; // 如果無值，預設升序
    },
    isUpdatedAfterAudit(item) {
      if (!item.updatedAt || !item.AuditedAt) return false;

      // 比较日期和时间
      return item.updatedAt.getTime() > item.AuditedAt.getTime();
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen; // 切換選單狀態
    },
    selectItemsPerPage(item) {
      this.itemsPerPage = item; // 更新每頁顯示的數量
      this.dropdownOpen = false; // 關閉下拉選單
      this.currentPage = 1; // 重置到第一頁，避免顯示錯位
    },
    handleGlobalClick(event) {
      // 檢查點擊是否發生在選單範圍內
      if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
        this.dropdownOpen = false; // 點擊外部時關閉選單
      }
    },
    goToPage(page) {
      if (typeof page === "number" && page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    formatToDateOnly(date) {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // 返回日期部分
    },

    formatDate(date) {
      if (!date) return "無";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0"); // 月份補零
      const day = String(d.getDate()).padStart(2, "0"); // 日期補零
      return `${year} 年 ${month} 月 ${day} 日`;
    },
    handleDateRangeChange(rangeType, value) {
      if (!value) {
        this.filters[rangeType] = []; // 將 null 轉為空陣列
      } else {
        this.filters[rangeType] = value;
      }
    },
    formatRange(range) {
      if (!range || range.length !== 2) return "";
      const [start, end] = range;
      return `${start.toISOString().split("T")[0]} ~ ${end.toISOString().split("T")[0]}`;
    },

    formatLanguage(language) {
      // 如果 language 為空值或非字串，回傳空字串
      if (!language || typeof language !== "string") return "";

      // 移除多餘空白和空值
      const cleanedLanguages = language
        .split(",")
        .map((lang) => lang.trim()) // 去掉空白
        .filter((lang) => lang); // 過濾空字串

      // 組合為逗號分隔的字串
      return cleanedLanguages.join(", ");
    },
    async fetchTools() {
      try {
        const baseUrlo = process.env.VUE_APP_SERVICE_URL;
        const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;

        // 取得推薦工具的排序
        const recommendResponse = await axios.get(`${baseUrl}/searchRecommend`);
        let recommendedTools = [];

        if (recommendResponse.data.rtnCode === "0000") {
          recommendedTools = recommendResponse.data.data.map(tool => ({
            id: tool.Codeno,
            name: tool.Name,
            sortBy: tool.SortBy
          }));
        } else {
          console.error("推薦工具 API 錯誤:", recommendResponse.data.rtnMsg);
        }

        // 取得所有工具
        const response = await axios.get(`${baseUrl}/ToolsList`);
        if (response.data.rtnCode !== "0000") {
          console.error("API 返回錯誤:", response.data.rtnMsg);
          return;
        }

        // 轉換 API 回應資料
        let allTools = response.data.data.map(tool => ({
          id: tool.codeno,
          name: tool.name,
          is_open_source: tool.public,
          main_category: tool.classtype,
          latest_version_date: this.parseCustomDate(tool.versionDate),
          status: tool.status,
          is_published: tool.releaseStatus,
          recommend: recommendedTools.some(r => r.id === tool.codeno), // 是否為推薦工具
          sortBy: recommendedTools.find(r => r.id === tool.codeno)?.sortBy ?? null // 如果有 SortBy，則存入
        }));

        // **排序邏輯**
        this.items = allTools.sort((a, b) => {
          if (a.sortBy !== null && b.sortBy !== null) {
            return a.sortBy - b.sortBy; // 先按照 SortBy 排序
          } else if (a.sortBy !== null) {
            return -1; // `SortBy` 有值的排在前面
          } else if (b.sortBy !== null) {
            return 1; // `SortBy` 有值的排在前面
          } else {
            return new Date(b.latest_version_date) - new Date(a.latest_version_date); // 其他工具按最新版本日期降序
          }
        });

      } catch (error) {
        console.error("獲取工具列表失敗:", error);
      }
    }
    ,


    parseCustomDate(dateString) {
      if (!dateString) return null;
      const parts = dateString.match(/(\d{4}) 年 (\d{2}) 月 (\d{2}) 日/);
      if (!parts) return null;

      const [, year, month, day] = parts;
      return new Date(`${year}-${month}-${day}`);
    },

    openDialog(type, tool) {
      this.dialogType = type;        // 設定對話框類型
      this.selectedTool = tool;      // 儲存被選中的工具
      this.dialogVisible = true;     // 開啟對話框
      this.auditStatus = "";         // 重置審核狀態
      this.reason = "";              // 清空理由

      if (type === "disable") {
        this.reason = ""; // 停用需要理由
      }
    },


    closeDialog() {
      this.dialogVisible = false;    // 關閉對話框
      this.auditStatus = "";         // 重置審核狀態
      this.reason = "";              // 清空理由
    },
    confirmAction() {
      const baseUrlo = process.env.VUE_APP_SERVICE_URL;
      const baseUrl = process.env.VUE_APP_BASE_URL || `${baseUrlo}/api/v1`;

      if (this.dialogType === 'audit' && this.auditStatus === 'failed') {
        // 審核未通過
        if (!this.reason) {
          alert('請提供未通過的理由！');
          return;
        }

        axios
          .post(`${baseUrl}/ToolsAuditNOT/${this.selectedTool.id}`, { reason: this.reason })
          .then((response) => {
            if (response.data.rtnCode === '0000') {
              console.log(`工具: ${this.selectedTool.name} 審核未通過，理由: ${this.reason}`);
              this.fetchTools(); // 刷新工具列表
              this.closeDialog(); // 關閉對話框
            } else {
              console.error('未通過審核失敗:', response.data.rtnMsg);
              alert(`未通過審核失敗: ${response.data.rtnMsg}`);
            }
          })
          .catch((error) => {
            console.error('未通過審核請求失敗:', error);
            alert('未通過審核請求失敗，請稍後再試。');
          });
      } else if (this.dialogType === 'audit' && this.auditStatus === 'passed') {
        // 審核通過邏輯
        axios
          .post(`${baseUrl}/ToolsAuditOK/${this.selectedTool.id}`, { id: this.selectedTool.id })
          .then((response) => {
            if (response.data.rtnCode === '0000') {
              console.log(`工具: ${this.selectedTool.name} 審核通過`);
              this.fetchTools(); // 刷新工具列表
              this.closeDialog(); // 關閉對話框
            } else {
              console.error('審核通過失敗:', response.data.rtnMsg);
              alert(`審核通過失敗: ${response.data.rtnMsg}`);
            }
          })
          .catch((error) => {
            console.error('審核請求失敗:', error);
            alert('審核請求失敗，請稍後再試。');
          });
      } else if (this.dialogType === 'disable') {
        // 下架邏輯
        if (!this.reason) {
          alert('請提供下架的理由！');
          return;
        }

        axios
          .post(`${baseUrl}/ToolsEditStop/${this.selectedTool.id}`, { reason: this.reason })
          .then((response) => {
            if (response.data.rtnCode === '0000') {
              console.log(`工具: ${this.selectedTool.name} 已下架`);
              this.fetchTools(); // 刷新工具列表
              this.closeDialog(); // 關閉對話框
            } else {
              console.error('下架失敗:', response.data.rtnMsg);
              alert(`下架失敗: ${response.data.rtnMsg}`);
            }
          })
          .catch((error) => {
            console.error('下架請求失敗:', error);
            alert('下架請求失敗，請稍後再試。');
          });
      } else if (this.dialogType === 'publish') {
        // 上架邏輯
        axios
          .post(`${baseUrl}/ToolsRelease/${this.selectedTool.id}`)
          .then((response) => {
            if (response.data.rtnCode === '0000') {
              console.log(`工具: ${this.selectedTool.name} 已上架`);
              this.fetchTools(); // 刷新工具列表
              this.closeDialog(); // 關閉對話框
            } else {
              console.error('上架失敗:', response.data.rtnMsg);
              alert(`上架失敗: ${response.data.rtnMsg}`);
            }
          })
          .catch((error) => {
            console.error('上架請求失敗:', error);
            alert('上架請求失敗，請稍後再試。');
          });
      }
    }
    ,


    sortTable(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc"; // 切換排序順序
      } else {
        this.sortKey = key;
        this.sortOrder = "asc"; // 默認升序
      }

      this.saveSortState(); // 每次修改排序時保存狀態

      // 排序邏輯
      this.items.sort((a, b) => {
        const valueA = a[key];
        const valueB = b[key];

        if (this.sortOrder === "asc") {
          return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
        } else {
          return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
        }
      });
    },

    getSortIcon(key) {
      if (this.sortKey !== key) return "mdi-swap-vertical";
      return this.sortOrder === "asc" ? "mdi-arrow-up" : "mdi-arrow-down";
    },
    applyFilters() {
      // 清理語言篩選值
      if (Array.isArray(this.filters.language)) {
        this.filters.language = this.filters.language
          .map((lang) => lang.trim())
          .filter((lang) => lang); // 過濾掉空值
      }
      console.log("篩選條件已應用：", this.filters);
    },

    clearFilters() {
      this.filters = {
        name: "",
        is_open_source: "",
        main_category: "",
        language: [],
        status: "",
        is_published: "",
        creationDateRange: [], // 確保為空數組
        modificationDateRange: [], // 確保為空數組
      };
    },
    addTool() {
      this.$router.push({ name: "AddTool" }); // 跳轉到新增工具頁面
    },

    closeAddDialog() {
      this.addDialogVisible = false; // 關閉對話框
    },
    confirmAddTool() {
      if (!this.newToolData.name) {
        alert("請填寫工具名稱！");
        return;
      }
      // 模擬新增工具
      const newTool = {
        id: this.items.length + 1, // 自動生成 ID
        ...this.newToolData,
        status: "待審核",
        is_published: "否",
        release_date: "",
      };
      this.items.push(newTool); // 添加到工具列表
      this.closeAddDialog(); // 關閉對話框
    },
    viewItem(item) {
      this.$router.push({
        name: "ViewTool",
        params: { id: item.id }, // 傳遞工具 ID
      });
    },
    editItem(item) {
      this.$router.push({
        name: "EditTool",
        params: { id: item.id }, // 傳遞工具 ID
      });
    },

  },
};
</script>

<style scoped>
/* 自定義回答框樣式 */
/* 保持回答框一致的樣式 */
.answer-input {
  display: flex;
  align-items: center;
  /* 垂直置中 */
  justify-content: center;
  /* 水平置中（視需要） */
  height: 100%;
  /* 確保容器有高度，才會有效果 */
}

.answer-label {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 8px;
}

.answer-input-field {
  width: 100%;
  height: 42px;
  /* 確保高度一致 */
  padding: 10px 12px;
  /* 與下拉框一致的內邊距 */
  font-size: 14px;
  /* 確保文字大小一致 */
  color: #333;
  /* 字體顏色統一 */
  border: 1px solid #dcdcdc;
  /* 邊框樣式 */
  border-radius: 8px;
  /* 圓角樣式 */
  outline: none;
  background-color: #ffffff;
  transition: border-color 0.2s, background-color 0.2s;
  /* 增加過渡效果 */
  appearance: none;
  /* 去掉瀏覽器預設樣式 */
  -webkit-appearance: none;
  /* Safari 適配 */
}



/* 焦點時的樣式 */
.answer-input-field:focus {
  border-color: #1976d2;
  background-color: #ffffff;
  box-shadow: 0 0 4px rgba(25, 118, 210, 0.2);
}

.answer-input-field::placeholder {
  color: #333;
  /* 統一 placeholder 顏色 */

}

::v-deep(.dp__input) {
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  border-radius: 8px;
  /* 確保與輸入框一致 */
  height: 42px;
  /* 確保高度一致 */
}

::v-deep(.dp__input::placeholder) {
  color: #333 !important;
  font-size: 14px !important;
  font-weight: normal !important;
  opacity: 1 !important;
  /* 確保不受透明度影響 */
}

/* 下拉選單箭頭樣式 */
select.answer-input-field {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%23000000' d='M7 10l5 5 5-5H7z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  padding-right: 36px;
  /* 預留空間給箭頭 */
}


/* 每頁顯示筆數選擇器樣式 */
.dropdown-container {
  position: relative;
  display: inline-block;
  width: 120px;
  font-size: 14px;
}

.dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dropdown-selected:hover {
  border-color: #1976d2;
  background-color: #f9f9f9;
}

.dropdown-icon {
  font-size: 12px;
  color: #666;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0;
  z-index: 100;
}

.dropdown-label {
  font-size: 14px;
  color: #333;
  margin-left: 10px;
  /* 左邊增加間距 */
  margin-right: 5px;
  /* 添加適當的間距 */
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: #e3f2fd;
}

.dropdown-item.active {
  background-color: #1976d2;
  color: white;
}

/* 標題與新增按鈕 */
.header-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.add-tool-btn {
  font-size: 14px;
  text-transform: none;
}


/* 修改 VueDatePicker 容器樣式 */
.vue-datepicker {
  width: 100%;
  /* 撐滿父容器 */
  height: 60px;
  /* 與其他篩選框高度一致 */
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 10px 12px;
  /* 與其他框的內邊距一致 */
  font-size: 14px;
  background-color: #ffffff;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.2s, background-color 0.2s;
}

/* 焦點樣式 */
.vue-datepicker:focus-within {
  border-color: #1976d2;
  box-shadow: 0 0 4px rgba(25, 118, 210, 0.2);
}

/* VueDatePicker 的內部輸入框樣式 */
.vue-datepicker input {
  border: none;
  outline: none;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: inherit;
  /* 繼承父容器字體大小 */
  background-color: transparent;
}

/* 選擇日期時彈出框的樣式 */
.vue-datepicker-popup {
  position: absolute;
  z-index: 1050;
  background-color: #ffffff;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}


.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

/* 整體背景樣式 */
.overview-page {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding: 20px;
}

/* 篩選條樣式 */
.filter-card {
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
}

.filter-actions {
  margin-top: 10px;
}



/* 表格樣式 */
.table-card {
  border-radius: 8px;
  overflow: hidden;
  padding: 16px;
  border: 1px solid #dcdcdc;
  background-color: #ffffff;
  position: relative;
  margin-bottom: 20px;
  /* 增加與分頁的間距 */
}

.pagination-container {
  display: flex;
  justify-content: center;
  /* 水平置中 */
  align-items: center;
  gap: 10px;
  /* 元素間的間距 */
  padding: 10px 0;
  /* 上下內邊距 */

  /* 背景與表格一致 */
  border-top: 1px solid #dcdcdc;
  /* 分隔線 */
}


.table-header-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.add-tool-btn {
  font-size: 14px;
  text-transform: none;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

.table-header {
  background-color: #333333;
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  border-bottom: 1px solid #dcdcdc;
  cursor: pointer;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-icon {
  font-size: 14px;
  margin-left: 4px;
  color: white;
}



.table-cell {
  text-align: center;
  padding: 8px;
  border-bottom: 1px solid #dcdcdc;
}

.v-card-title {
  font-weight: bold;
}

.v-card-text p {
  margin-bottom: 16px;
}

.v-radio-group {
  margin-bottom: 16px;
}

.v-textarea {
  margin-top: 16px;
}

.v-card-actions {
  justify-content: flex-end;
}

.pagination-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding: 10px 0;
}

.current-page-info {
  margin: 0 15px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.page-select,
.items-per-page-select {
  max-width: 100px;
  margin-left: 10px;
}


.items-per-page-select {
  max-width: 150px;
}

.custom-pagination {
  margin-top: 10px;
  justify-content: center;
}


.v-pagination {
  background-color: #f5f5f5;
  padding: 8px 16px;
  border-radius: 8px;
}

.v-pagination .v-pagination__item {
  color: #333;
  font-size: 14px;
  font-weight: bold;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.v-pagination .v-pagination__item--active {
  background-color: #1976d2;
  /* 主題顏色 */
  color: white;
}

.btn-disabled {
  background-color: #e9dede !important;
  /* 灰色背景 */
  color: #a0a0a0 !important;
  /* 字體顏色變灰 */
  cursor: not-allowed;
  /* 滑鼠變為禁止符號 */
  border-color: #dcdcdc !important;
  /* 灰色邊框 */
}

.btn-active {
  background-color: #1976d2;
  color: white;
  font-weight: bold;
}

.pagination-container .arrow-btn,
.pagination-container .page-btn {
  background: none;
  /* 移除背景 */
  border: none;
  /* 移除邊框 */
  color: #333;
  /* 按鈕文字顏色 */
  cursor: pointer;
  /* 鼠標樣式 */
  font-size: 14px;
  /* 統一字體大小 */
  padding: 0 8px;
  /* 左右內邊距 */
}

.pagination-container .arrow-btn:hover,
.pagination-container .page-btn:hover {
  color: #1976d2;
  /* 滑鼠懸停時改變顏色 */
}

.clickable-icon {
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}

.clickable-icon:hover {
  color: #1976d2 !important;
}

.v-dialog {
  z-index: 9999 !important;
  /* 確保在最頂層 */
}
/* 限定 .custom-table 只影響對話框內的表格 */
.v-dialog .custom-table {
  width: 100%;
  border-collapse: collapse;
  text-align: center; /* 讓整個表格內容置中 */
}

.v-dialog .custom-table th,
.v-dialog .custom-table td {
  text-align: center; /* 讓表頭 (th) 和內容 (td) 水平置中 */
  vertical-align: middle; /* 讓內容垂直置中 */
  padding: 10px; /* 增加內距，讓表格更好看 */
}

.v-dialog .custom-table th {
  background-color: #0e0d0d; /* 讓表頭有點區別 */
  color: #ffffff;
  font-weight: bold;
}

/* 讓編輯順序的上下按鈕沒有背景色、邊框、圓框 */
.v-dialog .custom-table td .v-btn {
  min-width: 0;  /* 移除最小寬度 */
  width: auto;  /* 根據內容調整大小 */
  height: auto;
  padding: 4px; /* 讓按鈕內距小一點 */
  border: none; /* 移除邊框 */
  background: none; /* 移除背景色 */
  box-shadow: none; /* 移除陰影 */
}

/* 讓 v-icon 比較大且更容易點擊 */
.v-dialog .custom-table td .v-btn v-icon {
  font-size: 18px;
  color: #333; /* 設定箭頭顏色 */
  cursor: pointer;
}

/* 滑鼠懸停時，讓箭頭變色 */
.v-dialog .custom-table td .v-btn:hover v-icon {
  color: #1976d2; /* Vuetify 主要顏色 */
}

</style>
